export const FETCH_ACCOUNT_REQUEST = "FETCH_ACCOUNT_REQUEST";
export const FETCH_ACCOUNT_SUCCESS = "FETCH_ACCOUNT_SUCCESS";
export const FETCH_ACCOUNT_FAILURE = "FETCH_ACCOUNT_FAILURE";

export const FETCH_ALL_ACCOUNT_SUCCESS = "FETCH_ALL_ACCOUNT_SUCCESS";

export const FETCH_PLAIN_PASSWORD = "FETCH_PLAIN_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";

export const REQUEST_HANDLER = "REQUEST_HANDLER";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";

export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
